export enum ApiQueryKeys {
	userInfo = 'user-info',
	userStore = 'user-store',
	getStoreByName = 'get-store-by-name',
	getStoreThemeByName = 'get-store-theme-by-name',
	getStoreByTradeName = 'get-store-by-trade-name',
	getAllPrompts = 'all-prompts',
	getPromptById = 'get-prompt-by-id',
	getDefaultPrompt = 'default-prompt',
	getAllHaggleEvents = 'all-haggle-events',
	getHaggleEventById = 'get-haggle-event-by-id',
	getAllStoreProducts = 'all-store-products',
	getChatById = 'get-chat-by-id',
	getAllHaggleEventByProductId = 'all-haggle-events-by-product-id',
	getProductById = 'get-product-by-id',
	userChats = 'user-chats',
	getAllHaggleEventsAdmin = 'all-haggle-events-admin.',
	getAllMerchants = 'all-merchants',
	getAllStores = 'all-stores',
	getUserById = 'get-user-by-id',
	getAllProductsByStoreName = 'get-all-products-by-store-name',
	getAllProducts = 'all-products',
	getAllHaggleProducts = 'all-haggle-products',
	getAllStoresPublic = 'all-stores-public',
	getAllStoreProductsWithHaggle = 'all-store-products-with-haggle',
	getStoreProductsWithHaggleByUserId = 'store-products-with-haggle-by-user-id',
	getAllHaggleStoredFilters = 'all-haggle-stored-filters',
	getHaggleEventSalesReport = 'get-haggle-event-sales-report',
	getHaggleEventMonthlySalesReport = 'get-haggle-event-monthly-sales-report',
	getAllNotifications = 'get-all-notifications',
	getMerchantHaggleChatCount = 'get-merchant-haggle-chat-count',
	getAllInvites = 'get-all-invites',
	getFavouritedNotifications = 'get-favourite-users',
	getDynamicPlans = 'get-dynamic-plans',
	getHaggleAllInvites = 'get-haggle-all-invites',
	createOrder = 'create-order',
	getOrders = 'get-orders',
	getMyOrders = 'get-my-orders',
	getOrderById = 'get-order-by-id',
	updateOrderStatus = 'update-order-status',
	addOrderTracking = 'add-order-tracking',
	getInvitesByEmail = 'get-invites-by-email',
	getUserByEmail = 'get-user-by-email',
	getSupportedStripeCountries = 'get-supported-countries',
	getLiveVendors = 'get-live-vendors',
	hasStoreProducts = 'has-store-products',
	syncStoreFromShopify = 'sync-store-from-shopify',
	getAllShopifySubscriptionDiscounts = 'get-all-shopify-subscription-discounts',
	getShopifySubscriptionDiscountById = 'get-shopify-subscription-discount-by-id',
}
